import Map from "./components/map";
import LocationChooser from "./components/location-chooser";
import LocationSearch from "btdt/components/location-search";
import {Loader} from "@googlemaps/js-api-loader";
import {apiKey, debug} from "btdt/config";
import {dataLayerPush, getLocations, objectEquals} from "btdt/shared";
import Drawer from "btdt/components/drawer";

import React from 'react';
import {createRoot} from 'react-dom/client';
import OrderForm from "btdt/react/OrderForm";

class BTDT {
    state = null
    watchers = []
    google = null
    locations = null
    debug = false
    drawerComponent = null
    mapComponent = null
    widgetComponents = []
    searchComponents = []

    constructor() {

        this.debug = debug

        const loader = new Loader({
            apiKey: apiKey, version: "weekly", libraries: ["maps", "places", "geometry", "marker"]
        });

        loader.load().then((google) => {
            this.google = google
            this.onLoad().then()
        })
    }

    async onLoad() {

        this.locations = await getLocations(false)

        const savedLocation = localStorage.getItem("btdt-location")
        const savedPlace = localStorage.getItem("btdt-place")

        const defaultState = {
            isLoading: false,
            isDrawerOpen: false,
            chosenLocation: savedLocation ? JSON.parse(savedLocation) : null,
            userPlace: savedPlace ? JSON.parse(savedPlace) : null,
            clickedMapLocation: null,
            clickedSearchLocationButton: null,
            clickedSearchLocationElement: null,
            searchLocationResults: null
        }

        this.state = new Proxy(defaultState, {
            set: (target, key, value) => {

                if (objectEquals(value, target[key])) {
                    return true
                }

                target[key] = value

                if (key === 'userPlace') {
                    if (debug) console.log('updating new userPlace in local storage', value)
                    window.localStorage.setItem("btdt-place", JSON.stringify(value))
                }

                if (key === 'chosenLocation') {
                    // need to delete some keys that do not like to be converted to JSON
                    delete value?.el
                    delete value?.marker
                    if (debug) console.log('updating new chosenLocation in local storage', value)
                    window.localStorage.setItem("btdt-location", JSON.stringify(value))
                }

                this.watchers.filter(l => l.key === key).forEach((w) => {
                    if (w?.callback && typeof w.callback === 'function') {
                        w.callback(value)
                    }
                })

                return true;
            }
        })

        this.addEventHandlers()
        this.setupButtons()
        this.pushGa4Info().then(() => {})

        const drawerEl = document.querySelector('.location-chooser-drawer')
        if (drawerEl) this.drawerComponent = new Drawer(drawerEl, this)

        const mapEl = document.querySelector('.finder-map')
        if (mapEl) this.mapComponent = new Map(mapEl, this)

        const searchEls = document.querySelectorAll('.location-chooser-search')
        searchEls.forEach(el => this.searchComponents.push(new LocationSearch(el, this)))

        const widgetEls = document.querySelectorAll('.location-chooser-widget')
        widgetEls.forEach(el => this.widgetComponents.push(new LocationChooser(el, this)))

        const domNode = document.getElementById('react-form');
        if (domNode) {
            const root = createRoot(domNode);
            root.render(<OrderForm app={this}/>);
        }

        if (debug) console.log('done btdt init')
    }

    addEventHandlers() {
        const toggles = document.querySelectorAll('[data-toggle-drawer], a[href="#location-drawer"]')
        toggles.forEach(t => {
            t.addEventListener('click', e => {
                e.preventDefault()
                this.setState('isDrawerOpen', !this.getState('isDrawerOpen'))
            })
        })
    }

    setupButtons() {
        const urlParams = new URLSearchParams(window.location.search)
        const franchise_id = urlParams.has('f') ? urlParams.get('f') : document.body.dataset.franchise
        const loc = this.locations.find(l => l.id === franchise_id)

        if (!franchise_id || !loc || !loc.simplified_booking) {
            return
        }
        const buttons = document.querySelectorAll('a[href*="/request-a-bin/"]')
        buttons.forEach(button => {
            const buttonUrl = new URL(button.getAttribute('href'), window.location.href)
            buttonUrl.searchParams.set('f', franchise_id)
            button.setAttribute('href', buttonUrl.toString())
        })
    }

    async pushGa4Info() {
        const pageLocation = document.head.querySelector('meta[name="location-name"]')
        const chosenLocation = this.getState('chosenLocation')
        if (pageLocation || !chosenLocation) {
            return
        }
        await dataLayerPush('franchise_track', {
            location: chosenLocation.location_name,
            ga4_id: chosenLocation.ga4_id
        })
    }

    getState(key) {
        return this.state[key]
    }

    setState(key, value) {
        this.state[key] = value
    }

    watchState(key, callback) {
        this.watchers.push({key, callback});
    }
}

const app = new BTDT()


